import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Zoom from '@material-ui/core/Zoom';
import { withData } from '../utility/DataContext';
import MemeDetail from './MemeDetail';


const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden'
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.15) 70%, rgba(0,0,0,0) 100%)',
  },
  loading: {
    width: '100%',
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4
  },
});


class TemplateShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templates: [],
      loaded: false,
      loadCount: 0
    };
    this.amount = 9;
    const templates = this.props.data.firestore.collection('templates');
    this.dbRefs = {
      latest: templates.orderBy('date', 'desc').limit(this.amount),
      often: templates.orderBy('count', 'desc').limit(this.amount),
    };
  }

  componentDidMount() {
    this.updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.loaded && this.state.loadCount === this.amount){
      this.setState({loaded: true});
    }
    if (prevProps.mode !== this.props.mode && this.props.mode !== 'total'){
      this.updateData();
    }
  }

  updateData = () => {
    this.setState({
      loaded: false,
      loadCount: 0,
      templates: [],
      template: null,
    }, () => {
      this.dbRefs[this.props.mode].get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          var data = doc.data();
          data.key = doc.id;
          data.date = data.date.toMillis();
          data.name = doc.id;
          this.setState(prevState => {
            return {templates: [...prevState.templates, data]};
          });
        });
      });
    });
  }

  onLoad = () => {
    this.setState({loadCount: this.state.loadCount + 1});
  }

  render() {
    const {classes} = this.props;
    return (
      <div className={classes.root}>
        {!this.state.loaded && 
          <Grid container justify="center" alignItems="center" className={classes.loading}>
            <CircularProgress color="primary" size={150} thickness={1.5} />
          </Grid>
        }
        <GridList cellHeight={150} cols={3} className={classes.gridList} spacing={0} style={{display: this.state.loaded ? 'flex' : 'none'}}>
          {this.state.templates.map((template, idx) => (
            <Zoom in={this.state.loaded} key={template.key} style={{ transitionDelay: this.state.loaded ? idx * 50 : 0}}>
              <GridListTile onClick={() => {this.setState({template: null}, ()=>this.setState({template: template}))}} style={{cursor: 'pointer'}}>
                <img src={template.url} onLoad={this.onLoad} alt={template.key} />
                <GridListTileBar
                  title={template.key} className={classes.titleBar}
                />
              </GridListTile>
            </Zoom>
          ))}
        </GridList>
        <MemeDetail template={this.state.template} />
      </div>
    );
  }
}

export default withData(withStyles(styles)(TemplateShow));


// WEBPACK FOOTER //
// ./src/components/TemplateShow.js